import { waitForImage } from "common/utils/ui/wait_for";
import ProductCardMadeCanvasClass from "components/jiffy/product-card-v3/made-canvas/made-canvas-class";
import DesignUploadCtaPlpCookieClass from "../design-upload-cta-plp/design-upload-cta-plp-cookie-class";

const restorePreview = async () => {
  const url = DesignUploadCtaPlpCookieClass.previewUrl;
  if (!url) return;

  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.get("bare") === "true") return;

  await new ProductCardMadeCanvasClass({ url }).init();

  const { $previews } = ProductCardMadeCanvasClass;
  if (!$previews?.length) return;

  const setPreviewDimensions = $preview => {
    $preview.setAttribute("data-width", $preview.naturalWidth);
    $preview.setAttribute("data-height", $preview.naturalHeight);
  };

  const processPreview = async $preview => {
    const src = $preview.currentSrc || $preview.src;
    const hasZoom = $preview.hasAttribute("data-zoom-src");

    if (hasZoom) {
      $preview.setAttribute("data-zoom-src", src);

      if ($preview.complete && $preview.naturalWidth) {
        setPreviewDimensions($preview);
      } else {
        await waitForImage($preview);
        setPreviewDimensions($preview);
      }
    }

    const $parent = $preview.parentNode;
    if ($parent?.hasAttribute("data-img-src")) {
      $parent.setAttribute("data-img-src", src);
    }
  };

  await Promise.all(Array.from($previews).map(processPreview));
};

export default restorePreview;
